import React from 'react'
import styles from './styles.css'
import {DropTarget} from 'react-dnd'
import ContractImage from 'App/components/ContractImage'
import PropTypes from 'prop-types'
import {findDOMNode} from 'react-dom'
import Field from '../Field'

const pageSource = {
  drop(props, monitor, component) {
    const item = monitor.getItem()
    const initialClientOffset = monitor.getInitialClientOffset()
    const mouseLeft = initialClientOffset.x - item.left
    const mouseTop = initialClientOffset.y - item.top
    // eslint-disable-next-line
    const componentRect = findDOMNode(component).getBoundingClientRect()
    const clientOffset = monitor.getClientOffset()
    const positionTop = (clientOffset.y - componentRect.top - mouseTop) / componentRect.height
    const positionLeft = (clientOffset.x - componentRect.left - mouseLeft) / componentRect.width
    const itemWidth = item.width / componentRect.width
    const itemHeight = item.height / componentRect.height
    const field = {
      page: props.page.index,
      x: positionLeft,
      y: positionTop,
      width: itemWidth,
      height: itemHeight,
      type: item.type,
      filler: null,
      label: null,
      value: null,
      required: true,
      name: null,
      validation: null,
      textSize: null
    }
    if (item.field) {
      field.filler = item.field.filler
      field.label = item.field.label
      field.required = item.field.required
      field.value = item.field.value
      field.name = item.field.name
      field.textSize = item.field.textSize
      props.updateField(item.field.id, field)
    } else {
      if (field.type === 'signature') {
        field.width = 200 / componentRect.width
        field.height = 100 / componentRect.height
      }
      if (field.type === 'text') {
        field.width = 200 / componentRect.width
        field.height = 20 / componentRect.height
      }
      if (field.type === 'checkbox') {
        field.width = 20 / componentRect.width
        field.height = 20 / componentRect.height
      }
      const fieldId = props.addField(field)
      props.openFieldMenu(fieldId)
    }
  },
  canDrop(props, monitor) {
    return monitor.getItem()
  }
}

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget()
  }
}

@DropTarget('field', pageSource, collect)
export default class Page extends React.Component {
  static propTypes = {
    page: PropTypes.object,
    connectDropTarget: PropTypes.func,
    fields: PropTypes.array,
    updateField: PropTypes.func,
    deleteField: PropTypes.func,
    template: PropTypes.object,
    openFieldMenu: PropTypes.func,
    openedFieldMenu: PropTypes.string
  }

  state = {}

  componentDidMount() {
    const height = this.reference.clientWidth * this.props.page.height / this.props.page.width
    this.setState({height})
  }

  updateField(field, data) {
    const newField = {...field, ...data}
    this.props.updateField(field.id, newField)
  }

  renderFields() {
    if (!this.state.height) return
    return this.props.fields.map(field => {
      return (
        <Field
          key={field.id}
          field={field}
          template={this.props.template}
          type={field.type}
          height={this.state.height}
          page={this.props.page}
          resizing={this.state.resizing}
          setResizing={resizing => this.setState({resizing})}
          onUpdate={data => this.updateField(field, data)}
          delete={() => this.props.deleteField(field.id)}
          menuOpened={this.props.openedFieldMenu === field.id}
          openMenu={() =>
            field.id === this.props.openedFieldMenu
              ? this.props.openFieldMenu(null)
              : this.props.openFieldMenu(field.id)
          }
          closeMenu={() => this.props.openFieldMenu(null)}
        />
      )
    })
  }

  render() {
    return this.props.connectDropTarget(
      <div className={styles.container}>
        <div
          ref={reference => {
            this.reference = reference
          }}
        />
        <ContractImage
          onClick={() => this.props.openFieldMenu(null)}
          height={this.state.height}
          page={this.props.page}
        />
        {this.renderFields()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/PrepareTemplate/Page/index.js